import clsx from 'clsx';

type Props = React.ComponentProps<'label'> & {
  isActive?: boolean;
  readOnly?: boolean;
  error?: string;
  required?: boolean;
};
export function Label({
  readOnly,
  isActive,
  required,
  error,
  className,
  ...props
}: Props): React.JSX.Element {
  const status = readOnly
    ? 'readOnly'
    : error
      ? 'error'
      : isActive
        ? 'active'
        : 'default';

  const cn = clsx(
    className,
    'relative flex justify-between pb-1 text-sm font-bold capitalize',
    required &&
      'pl-2 before:absolute before:left-0 before:top-0 before:w-2 before:text-tomato9 before:content-[*]',
    (status === 'readOnly' || status === 'default') && 'text-slate11',
    status === 'error' && 'text-tomato9',
    status === 'active' && 'text-blue11'
  );

  // eslint-disable-next-line jsx-a11y/label-has-associated-control
  return <label {...props} className={cn} />;
}
